"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMessageRelation = exports.postMessageRelation = exports.putMessageOrganization = exports.putMessageAccessibility = exports.deleteMessagePermission = exports.postMessagePermission = exports.delMessage = exports.postMessage = exports.getMessage = exports.getMessages = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var path = root_1.crmAuthorized + '/messages/';

var getMessages = function getMessages(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getMessages = getMessages;

var getMessage = function getMessage(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getMessage = getMessage;

var postMessage = function postMessage(authentication, message) {
  return common_1.post(authentication, path, message);
};

exports.postMessage = postMessage;

var delMessage = function delMessage(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delMessage = delMessage;

var postMessagePermission = function postMessagePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, path, id, permission);
};

exports.postMessagePermission = postMessagePermission;

var deleteMessagePermission = function deleteMessagePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, path, id, permissionId);
};

exports.deleteMessagePermission = deleteMessagePermission;

var putMessageAccessibility = function putMessageAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, path, id, accessibility);
};

exports.putMessageAccessibility = putMessageAccessibility;

var putMessageOrganization = function putMessageOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, path, id, organizationId);
};

exports.putMessageOrganization = putMessageOrganization;

var postMessageRelation = function postMessageRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postMessageRelation = postMessageRelation;

var deleteMessageRelation = function deleteMessageRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deleteMessageRelation = deleteMessageRelation;